import {
  getCurrentFacilityId,
  UserGeneralInfoContextKeys,
  userLoggedInFacilityType,
  UserStore,
} from "@risalabs_frontend_org/auth-wrapper";

/**
 * Gets the organization ID to use for API calls.
 * If the current facility is external, returns the corresponding internal org ID.
 * Otherwise, returns the current facility ID.
 */
export const getOrgIdForFetchExternalWorklist = (): string => {
  const currentFacilityId = getCurrentFacilityId() || "";
  const correspondingInternalOrgId = UserStore.getItem(
    UserGeneralInfoContextKeys.INTERNAL_ORGANIZATION_FACILITY_ID,
  ) as string | null;

  if (
    correspondingInternalOrgId &&
    userLoggedInFacilityType(currentFacilityId) === "external"
  ) {
    return correspondingInternalOrgId;
  }

  return currentFacilityId;
};
